import React from 'react';

const WasteConfirmationModal = ({ isOpen, onClose, onConfirm, itemName }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-4" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="absolute inset-0 bg-black/80 backdrop-blur-sm transition-opacity"></div>

            <div className="relative bg-white dark:bg-[#1a1a1a] rounded-3xl w-full max-w-sm p-6 shadow-2xl animate-bounce-in border-4 border-slate-100 dark:border-gray-800">
                {/* Simple Close Icon */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors"
                >
                    <span className="material-symbols-outlined text-[20px]">close</span>
                </button>

                <div className="size-20 bg-red-50 dark:bg-red-900/20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner">
                    <span className="material-symbols-outlined text-4xl text-red-500">delete_forever</span>
                </div>

                <h3 className="text-xl font-black text-center text-slate-900 dark:text-white mb-3">
                    Stoktan Düşelim mi?
                </h3>

                <p className="text-center text-slate-500 dark:text-gray-400 font-medium mb-8 leading-relaxed">
                    Şefim, <strong className="text-slate-900 dark:text-white">{itemName}</strong> artık kurtarılamaz durumda diyorsan, seni dinleyip stoktan siliyorum?
                </p>

                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 h-12 rounded-xl bg-slate-100 dark:bg-gray-800 text-slate-600 dark:text-gray-300 font-bold text-xs uppercase tracking-wider hover:bg-slate-200 dark:hover:bg-gray-700 transition-colors"
                    >
                        Vazgeç, Dursun
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 h-12 rounded-xl bg-red-500 text-white font-bold text-xs uppercase tracking-wider shadow-lg shadow-red-500/30 hover:bg-red-600 transition-colors flex items-center justify-center gap-2"
                    >
                        <span className="material-symbols-outlined text-lg">delete</span>
                        Onayla ve Sil
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WasteConfirmationModal;
